"use client";

import { Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section4,
} from "../../../../../../public/images/blogs/realEstateAppraisal";

export default function BlogContent() {
  const t = useTranslations("blogs.successStory");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={section4}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
          })}
          src={header}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
